import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import BoxesTableRow from "./BoxesTableRow";

const BoxesTable = ({ boxes, handleUpdateBoxesChangeList, handleConfirmBoxDeletion }) => {
  const [localBoxes, setLocalBoxes] =
    useState(boxes);

  useEffect(() => {
    setLocalBoxes(boxes);
  }, [boxes]);

  const handleUpdateLocalBox = (field, value, boxId) => {
    let _box = localBoxes.find((b) => b.id === boxId);
    if (_box) {
        _box = { ..._box, [field]: value };
      setLocalBoxes(
        localBoxes.map((b) => (b.id === boxId ? _box : b))
      );
      handleUpdateBoxesChangeList(_box);
    }
  };

  return <div
  className="products-table-container-wrapper"
>
  <Typography className="products-table-heading">
    Boxes
  </Typography>
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 200 }}
        >
          <Typography
            variant="caption"
            className="products-table-header"
          >
            Name
          </Typography>
        </TableCell>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 50 }}
        >
          <Typography
            variant="caption"
            className="products-table-header"
          >
            Height
          </Typography>
        </TableCell>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 50 }}
        >
          <Typography
            variant="caption"
            className="products-table-header"
          >
            Width
          </Typography>
        </TableCell>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 50 }}
        >
          <Typography
            variant="caption"
            className="products-table-header"
          >
            Length
          </Typography>
        </TableCell>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 50 }}
        >
          <Typography
            variant="caption"
            className="products-table-header"
          >
            Min Capacity
          </Typography>
        </TableCell>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 50 }}
        >
          <Typography
            variant="caption"
            className="products-table-header"
          >
            Max Capacity
          </Typography>
        </TableCell>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 30 }}
        >
          
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {localBoxes
        .map((box, index) => (
          <BoxesTableRow
            key={index}
            index={index}
            box={box}
            handleUpdateLocalBox={handleUpdateLocalBox}
            handleConfirmBoxDeletion={handleConfirmBoxDeletion}
          />
        ))}
    </TableBody>
  </Table>
</div>;
};

export default BoxesTable;
